/* eslint-disable */

import React from "react";
import { Dimensions, Animated, Easing } from "react-native";
import { withRouter } from "react-router-dom";
import Finalloader from "./completeLoader";
import axios from "axios";
import Header from "../Components/MandG/Header";
import {
  ASPECTHEADERTEXT,
  BODYDESCRIPTION1,
  BODYDESCRIPTION2,
  BODYDESCRIPTION3,
  buttonText,
  EXPERIENCE,
  lossLabels,
  RISK,
  moduleid,
  THANK,
  ENDTEXT,
} from "../Utils/static-strings";
import {
  widthPercentageToDP as wp,
  heightPercentageToDP as hp,
} from "../Utils/responsive";
import { completedUserref } from "../Utils/path-config";
import { addAnalytics } from "../helper";

const scripts = [
  // { loading: fetch("https://d3e54v103j8qbb.cloudfront.net/js/jquery-3.5.1.min.dc5e7f18c8.js?site=60c7036946876984473b8df4").then(body => body.text()), isAsync: false },
  {
    loading: Promise.resolve(
      '$(document).ready(function(event){$("#pie-center").removeAttr("style"); $("#knowledge-segment-container").click(function(){$(".menu-pie").addClass("knowledge-game"),$(".content-block").fadeOut();setTimeout(function(){},1e3)}),$("#future-segment-container").click(function(){$(".menu-pie").addClass("future-game"),$(".content-block").fadeOut();setTimeout(function(){},1e3)}),$("#loss-segment-container").click(function(){$(".menu-pie").addClass("loss-game"),$(".content-block").fadeOut();setTimeout(function(){},1e3)}),$("#risk-segment-container").click(function(){$(".menu-pie").addClass("risk-game"),$(".content-block").fadeOut();setTimeout(function(){},1e3)}),$("#experience-segment-container").click(function(){$(".menu-pie").addClass("experience-game"),$(".content-block").fadeOut();setTimeout(function(){},1e3)}); });',
    ),
    isAsync: false,
  },
  // { loading: fetch("js/webflow.js").then(body => Promise.resolve(body.text())), isAsync: false },
  // { loading: fetch("https://code.jquery.com/jquery-3.6.0.min.js").then(body => body.text()), isAsync: false },
];

let Controller;
const firefox = typeof InstallTrigger !== "undefined";
class IndexView extends React.Component {
  animated1 = new Animated.Value(0);
  headerAnimation = new Animated.Value(0);
  spinner = new Animated.Value(0);
  opacity = new Animated.Value(1);
  popup = new Animated.Value(0);
  constructor() {
    super();
    this.state = {
      nobi: false,
      knowledge: false,
      loss: false,
      future: false,
      risk: false,
      experience: false,
      isCompleted: false,
      outerAnime: false,
      closeButton: true,
      headerText2: false,
      changeRotation: false,
      endText: false,
      completeLoader: false,
      pieHidden: false,
      knowledgeText: "",
      lossText: "",
      futureText: "",
      riskText: "",
      experienceText: "",
      continuePressed: false,
    };
    this.continueHandle = this.continueHandle.bind(this);
  }
  static get Controller() {
    if (Controller) return Controller;

    try {
      // Use dynamic require to avoid bundler resolution when controller is absent
      Controller = eval("require")("../controllers/IndexController");
      Controller = Controller.default || Controller;

      return Controller;
    } catch (e) {
      if (
        e &&
        (e.code === "MODULE_NOT_FOUND" ||
          (typeof e.message === "string" &&
            /require is not defined|Cannot find module/.test(e.message)))
      ) {
        Controller = IndexView;
        return Controller;
      }
      addAnalytics(e);
      throw e;
    }
  }

  continueHandle = () => {
    this.setState({ outerAnime: true });
    this.animatePrev();
  };
  closeIframe = () => {
    var refKey = this;
    this.setState({ closeButton: false });
    if (window.parent) {
      if (window.parent.postMessage) {
        const { userref, accessToken } = this.props;
        const config = {
          method: "post",
          url:
            window["runConfig"].REACT_APP_BASE_URL +
            completedUserref(userref, this.props.sessionref),
          headers: {
            "Content-Type": "application/json",
          },
          data: {},
        };
        axios(config)
          .then((response) => {
            refKey.setState({ completeLoader: false });
            refKey.setState({ endText: true });
            window.parent.postMessage(
              "surveycomplete",
              window["runConfig"].REACT_APP_RESEARCH_APP_URL,
            );
          })
          .catch(function (error) {
            addAnalytics(error, config);
            refKey.setState({ completeLoader: false });
            refKey.setState({ endText: true });
            window.parent.postMessage(
              "surveycomplete",
              window["runConfig"].REACT_APP_RESEARCH_APP_URL,
            );
          });
      }
    }
  };
  animatePrev = () => {
    Animated.timing(this.spinner, {
      toValue: 35,
      duration: 400,
      easing: Easing.linear,
    }).start(() => this.animate());
    Animated.timing(this.opacity, {
      toValue: 0,
      duration: 1000,
    }).start();
  };
  animatedLast = () => {
    Animated.timing(this.popup, {
      toValue: Dimensions.get("screen").width < 700 ? 1.65 : 1,
      duration: 800,
    }).start();
  };

  animate = () => {
    this.setState({ changeRotation: true });
    Animated.timing(this.animated1, {
      toValue: 35,
      duration: Dimensions.get("window").width <= 600 ? 500 : 900,
      easing: Easing.linear,
    }).start(() => {
      this.setState({ endText: true, pieHidden: true });
      this.animatedLast();
    });
  };

  rotateBack = this.spinner.interpolate({
    inputRange: [5, 20],
    outputRange: ["0deg", "-27deg"],
  });

  spin = this.animated1.interpolate({
    inputRange: [5, 20],
    outputRange: ["0deg", "360deg"],
  });
  translateX = this.animated1.interpolate({
    inputRange: [0, 35],
    outputRange: [wp("0%"), wp("100%")],
  });

  componentDidMount() {
    const { riskCalculation, setModuleName, finishAnimate, startDescale } =
      this.props;

    if (
      !this.props.modules?.modules.some(
        (module) => module.moduleid === moduleid.risk(),
      )
    ) {
      this.setState({ risk: true });
    }
    if (
      !this.props.modules?.modules.some(
        (module) => module.moduleid === moduleid.experience(),
      )
    ) {
      this.setState({ experience: true });
    }
    if (
      !this.props.modules?.modules.some(
        (module) => module.moduleid === moduleid.knowledge(),
      )
    ) {
      this.setState({ knowledge: true });
    }
    if (
      !this.props.modules?.modules.some(
        (module) => module.moduleid === moduleid.future(),
      )
    ) {
      this.setState({ future: true });
    }
    if (
      !this.props.modules?.modules.some(
        (module) => module.moduleid === moduleid.loss(),
      )
    ) {
      this.setState({ loss: true });
    }

    if (finishAnimate === null) {
    }
    if (finishAnimate === null && riskCalculation !== "") {
      startDescale();
    }
    if (finishAnimate !== null) {
      if (finishAnimate === moduleid.future()) {
        startDescale();
        setModuleName(moduleid.future());
      }
      if (finishAnimate === moduleid.risk()) {
        startDescale();
        setModuleName(moduleid.risk());
      }
      if (finishAnimate === moduleid.loss()) {
        startDescale();
        setModuleName(moduleid.loss());
      }
      if (finishAnimate === moduleid.knowledge()) {
        startDescale();
        setModuleName(moduleid.knowledge());
      }
      if (finishAnimate === moduleid.experience()) {
        startDescale();
        setModuleName(moduleid.experience());
      }
    }

    riskCalculation !== "" &&
      riskCalculation.modules.filter((val) => {
        this.setState({ isCompleted: true, headerText2: true });
        if (val.moduleid === moduleid.future()) {
          this.setState({ future: true });
        }
        if (val.moduleid === moduleid.risk()) {
          this.setState({ risk: true });
        }
        if (val.moduleid === moduleid.loss()) {
          this.setState({ loss: true });
        }
        if (val.moduleid === moduleid.knowledge()) {
          this.setState({ knowledge: true });
        }
        if (val.moduleid === moduleid.experience()) {
          this.setState({ experience: true });
        }
      });

    riskCalculation !== "" &&
      riskCalculation.calcresults.filter((val) => {
        if (val.moduleid === moduleid.future()) {
          this.setState({ futureText: val.chartvalues[0].label });
        }
        if (val.moduleid === moduleid.risk()) {
          this.setState({ riskText: val.chartvalues[0].label });
        }
        if (val.moduleid === moduleid.loss()) {
          this.setState({ lossText: val.chartvalues[0].label });
        }
        if (val.moduleid === moduleid.knowledge()) {
          this.setState({ knowledgeText: val.chartvalues[0].label });
        }
        if (val.moduleid === moduleid.experience()) {
          this.setState({ experienceText: val.chartvalues[0].label });
        }
      });

    const htmlEl = document.querySelector("html");
    htmlEl.dataset["wfPage"] = "60ded1c8dc06918539ff0fb4";
    htmlEl.dataset["wfSite"] = "60c7036946876984473b8df4";
    var rawFile = new XMLHttpRequest();
    let data = null;
    rawFile.open("GET", "/webflowScript.txt", false);
    rawFile.onreadystatechange = function () {
      if (rawFile.readyState === 4) {
        if (rawFile.status === 200 || rawFile.status === 0) {
          var allText = rawFile.responseText;
          data = allText;
        }
      }
    };
    rawFile.send(null);
    scripts.concat(null).reduce((active, next) =>
      Promise.resolve(active).then((active) => {
        const loading = active.loading.then((script) => {
          Function(script)();
          if (riskCalculation === "") {
            Function(data)();
          } else {
          }
          return next;
        });

        return active.isAsync ? next : loading;
      }),
    );
  }

  componentWillReceiveProps = (nextProps) => {
    const { check, setCheck } = this.props;
    if (nextProps.check !== this.props.check) {
      const htmlEl = document.querySelector("html");
      htmlEl.dataset["wfPage"] = "60ded1c8dc06918539ff0fb4";
      htmlEl.dataset["wfSite"] = "60c7036946876984473b8df4";
      scripts.concat(null).reduce((active, next) =>
        Promise.resolve(active)
          .then((active) => {
            const loading = active.loading.then((script) => {
              new Function(`
          with (this) {
            // console.log('po00',arguments[0])
            if(eval(arguments[0])){
            eval(arguments[0])
            }
          }
        `).call(window, script);
              return next;
            });

            return active.isAsync ? next : loading;
          })
          .catch((e) => {
            addAnalytics(e);
          }),
      );
    } else {
    }
  };

  navigate(route, animate) {
    this.props.setModuleName(route);
    this.setState({ nobi: !this.state.nobi });
    animate(true);
    setTimeout(() => {
      this.props.history.push(`/activityType/${route}`);
    }, 300);
  }

  handleButtonPress() {
    Animated.timing(this.headerAnimation, {
      toValue: 100,
      duration: 1200,
      easing: Easing.linear,
    });
  }

  render() {
    const { startAnimation, riskCalculation } = this.props;
    const {
      isCompleted,
      nobi,
      future,
      risk,
      knowledge,
      experience,
      loss,
      futureText,
      riskText,
      knowledgeText,
      experienceText,
      lossText,
      headerText2,
      changeRotation,
      outerAnime,
      endText,
      completeLoader,
    } = this.state;

    var futureClass = future ? "complete" : "";
    var riskClass = risk ? "complete" : "";
    var knowledgeClass = knowledge ? "complete" : "";
    var experienceClass = experience ? "complete" : "";
    var lossClass = loss ? "complete" : "";

    return (
      <div style={{ height: "100%", width: "100%" }}>
        <style
          dangerouslySetInnerHTML={{
            __html: `
          @import url(/css/normalize.css);
          @import url(/css/webflow.css);
          @import url(/css/pru-profiler-prototype.webflow.css);


          .segment-container{
            	cursor:pointer;
              transform-origin: center;
              transform: translate(42px, 42px) scale(1);
              transition: transform .2s;
          }
          @media (hover: hover) and (pointer: fine) {
            .segment-container:hover{
                transform-origin: center;
                transform: translate(46px, 46px) scale(1.1);
                transition: transform .2s;
            }
          }
          .segment-container.complete{
            	cursor:default;
              transform-origin: center;
              transform: translate(34px, 34px) scale(.8);
              transition: transform .2s;
              opacity:.5;
          }
          .deconstructed-menu .pie-center{
          		z-index:6;
          }
          body.skin-mandg .af-class-deconstructed-menu .af-class-menu-segment{
              opacity: 1 !important;
              transition: none !important;
          }
          .deconstructed-menu.knowledge-game,
          .deconstructed-menu.future-game,
          .deconstructed-menu.loss-game,
          .deconstructed-menu.risk-game,
          .deconstructed-menu.experience-game{
          		display:block!important;
              opacity:1!important;
          }
          /* Knowledge Game */
          .menu-pie.knowledge-game .pie-center{
          		animation: showknowledge 1s forwards;
            	background-image: none;
              transition: background-image: .3s;
          }
          /*.deconstructed-menu.knowledge-game .menu-segment.knowledge{
          		z-index:5;
          }
          .deconstructed-menu.knowledge-game .menu-segment.future{
          		animation: folds4 .8s ease forwards;
          		z-index:1;
          }
          .deconstructed-menu.knowledge-game .menu-segment.loss{
          		animation: folds3 .6s ease .2s forwards;
          		z-index:2;
          }
          .deconstructed-menu.knowledge-game .menu-segment.risk{
          		animation: folds2 .4s ease .4s forwards;
          		z-index:3;
          }
          .deconstructed-menu.knowledge-game .menu-segment.experience{
          		animation: folds1 .2s ease .6s forwards;
          		z-index:4;
          }  */
          @keyframes showknowledge {
            0% 	{
                }
            100% {
                transform: scale(11);
                background-color: #CCCBE3;
                }
          }
          /* Future Game */
          .menu-pie.future-game .pie-center{
          		animation: showfuture 1s forwards;
            	background-image: none;
              transition: background-image: .3s;
          }
          /*.deconstructed-menu.future-game .menu-segment.future{
          		z-index:5;
          }
          .deconstructed-menu.future-game .menu-segment.loss{
          		animation: folds4 .8s ease forwards;
          		z-index:1;
          }
          .deconstructed-menu.future-game .menu-segment.risk{
          		animation: folds3 .6s ease .2s forwards;
          		z-index:2;
          }
          .deconstructed-menu.future-game .menu-segment.experience{
          		animation: folds2 .4s ease .4s forwards;
          		z-index:3;
          }
          .deconstructed-menu.future-game .menu-segment.knowledge{
          		animation: folds1 .2s ease .6s forwards;
          		z-index:4;
          }  */
          @keyframes showfuture {
            0% 	{
                }
            100% {
                transform: scale(11);
                background-color: #BBDDF2;
                }
          }
          /* Loss Game */
          .menu-pie.loss-game .pie-center{
          		animation: showloss 1s forwards;
            	background-image: none;
              transition: background-image: .3s;
          }
          /*.deconstructed-menu.loss-game .menu-segment.loss{
          		z-index:5;
          }
          .deconstructed-menu.loss-game .menu-segment.risk{
          		animation: folds4 .8s ease forwards;
          		z-index:1;
          }
          .deconstructed-menu.loss-game .menu-segment.experience{
          		animation: folds3 .6s ease .2s forwards;
          		z-index:2;
          }
          .deconstructed-menu.loss-game .menu-segment.knowledge{
          		animation: folds2 .4s ease .4s forwards;
          		z-index:3;
          }
          .deconstructed-menu.loss-game .menu-segment.future{
          		animation: folds1 .2s ease .6s forwards;
          		z-index:4;
          }  */
          @keyframes showloss {
            0% 	{
                }
            100% {
                transform: scale(11);
                background-color: #F5D3E4;
                }
          }
          /* Risk Game */
          .menu-pie.risk-game .pie-center{
          		animation: showrisk 1s forwards;
            	background-image: none;
              transition: background-image: .3s;
          }
          /*.deconstructed-menu.risk-game .menu-segment.risk{
          		z-index:5;
          }
          .deconstructed-menu.risk-game .menu-segment.experience{
          		animation: folds4 .8s ease forwards;
          		z-index:1;
          }
          .deconstructed-menu.risk-game .menu-segment.knowledge{
          		animation: folds3 .6s ease .2s forwards;
          		z-index:2;
          }
          .deconstructed-menu.risk-game .menu-segment.future{
          		animation: folds2 .4s ease .4s forwards;
          		z-index:3;
          }
          .deconstructed-menu.risk-game .menu-segment.loss{
          		animation: folds1 .2s ease .6s forwards;
          		z-index:4;
          }  */
          @keyframes showrisk {
            0% 	{
                }
            100% {
                transform: scale(11);
                background-color: #C3E0B5;
                }
          }
          /* Experience Game */
          .menu-pie.experience-game .pie-center{
          		animation: showexperience 1s forwards;
            	background-image: none;
              transition: background-image: .3s;
          }
          /*.deconstructed-menu.experience-game .menu-segment.experience{
          		z-index:5;
          }
          .deconstructed-menu.experience-game .menu-segment.knowledge{
          		animation: folds4 .8s ease forwards;
          		z-index:1;
          }
          .deconstructed-menu.experience-game .menu-segment.future{
          		animation: folds3 .6s ease .2s forwards;
          		z-index:2;
          }
          .deconstructed-menu.experience-game .menu-segment.loss{
          		animation: folds2 .4s ease .4s forwards;
          		z-index:3;
          }
          .deconstructed-menu.experience-game .menu-segment.risk{
          		animation: folds1 .2s ease .6s forwards;
          		z-index:4;
          }    */
          @keyframes showexperience {
            0% 	{
                }
            100% {
                transform: scale(11);
                background-color: #FFEEC9;
                }
          }
          /* Folds */
          @keyframes folds4 {
            0% 	{transform: rotate(0deg);}
            25% {transform: rotate(72deg);}
            50% {transform: rotate(144deg);}
            75% {transform: rotate(216deg);}
            100% {transform: rotate(288deg);}
          }
          @keyframes folds3 {
            0% 	{transform: rotate(0deg);}
            33.33% {transform: rotate(72deg);}
            66.66% {transform: rotate(144deg);}
            100% {transform: rotate(216deg);}
          }
          @keyframes folds2 {
            0% 	{transform: rotate(0deg);}
            50% {transform: rotate(72deg);}
            100% {transform: rotate(144deg);}
          }
          @keyframes folds1 {
            0% 	{transform: rotate(0deg);}
            100% {transform: rotate(72deg);}
          }
        `,
          }}
        />

        <div className="af-view">
          <div className="af-class-body">
            <img
              className="risk-page-mandg-logo"
              src={require("../assets/images/mandg/logo.png")}
              alt="M&G"
            />
            {/* <div className="af-class-header"> */}
            <Header currentRoute={"Understanding"} row={{ top: 10 }} />
            {/* </div> */}

            {endText && (
              <div
                style={{
                  justifyContent: "center",
                  display: "flex",
                  height: "100%",
                  width: "100%",
                  position: "absolute",
                  zIndex: 55,
                }}
              >
                <Animated.View
                  style={{
                    // right: '50%',
                    height: "100%",
                    width: "100%",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <h2 style={{ fontWeight: 600, marginBottom: 24 }}>{THANK}</h2>
                  <p className="af-class-large" style={{ textAlign: "center" }}>
                    {ENDTEXT}
                  </p>

                  <a
                    data-w-id="21d44e33-f1b1-0eb8-9bf2-929abc310957"
                    onClick={(e) => {
                      e.preventDefault();
                      if (this.state.closeButton) {
                        this.setState({ completeLoader: true });
                        this.setState({ endText: false });
                        this.closeIframe();
                      }
                    }}
                    href="#"
                    className="af-class-button w-inline-block"
                  >
                    <div style={{ fontWeight: "var(--font-weight-semi-bold)" }}>
                      Close
                    </div>
                  </a>
                </Animated.View>
              </div>
            )}
            {completeLoader && <Finalloader />}

            <div className="af-class-contents">
              {!endText && (
                <div
                  className="af-class-content-block af-class-main w-container"
                  style={
                    isCompleted
                      ? {
                          width: "650px",
                          height: "0px",
                          transform:
                            "translate3d(0px, -15px, 0px) scale3d(0.6, 0.6, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)",
                          transformStyle: "preserve-3d",
                        }
                      : {}
                  }
                >
                  <Animated.View
                    style={{
                      opacity: this.opacity,
                      marginTop:
                        Dimensions.get("window").width <= 600 ? 50 : 98,
                      transform: [{ scale: 1 }],
                    }}
                  >
                    <div className="risk-page-title-block">
                      <div
                        style={{
                          transform:
                            Dimensions.get("screen").width === 320
                              ? "  scale3d(0.6, 0.6, 1) "
                              : null,
                        }}
                      >
                        <h2 style={{ fontWeight: 600 }}>{ASPECTHEADERTEXT}</h2>
                      </div>
                    </div>
                  </Animated.View>

                  <p
                    data-w-id="824714b0-2f2e-5531-aa4b-be8c28d63658"
                    style={Object.assign(
                      isCompleted && { display: "none", opacity: 0 },
                    )}
                    className="af-class-large"
                  >
                    {BODYDESCRIPTION1}
                    <br />‍<br />
                    <span
                      dangerouslySetInnerHTML={{ __html: BODYDESCRIPTION2 }}
                    ></span>
                    <br />
                    <br />
                    <span
                      dangerouslySetInnerHTML={{ __html: BODYDESCRIPTION3 }}
                    ></span>
                  </p>
                  <a
                    data-w-id="21d44e33-f1b1-0eb8-9bf2-929abc310957"
                    style={Object.assign(
                      isCompleted && { display: "none", opacity: 0 },
                    )}
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ continuePressed: true });
                      setTimeout(() => {
                        this.setState({ nobi: true });
                      }, 1500);
                    }}
                    href="#"
                    className="af-class-button w-inline-block"
                  >
                    <div
                      style={{ fontWeight: "var(--font-weight-semi-bold)" }}
                      onClick={() => this.handleButtonPress()}
                    >
                      {buttonText}
                    </div>
                  </a>
                </div>
              )}

              <div
                className="af-class-menu-pie"
                style={Object.assign(
                  isCompleted && {
                    display: "flex",
                    position: `${endText ? "relative" : "absolute"}`,
                  },
                  (this.state.pieHidden || completeLoader) && {
                    visibility: "hidden",
                    pointerEvents: "none",
                  },
                )}
              >
                {/* display: flex; */}
                {!endText && (
                  <Animated.View
                    style={Object.assign(
                      future &&
                        loss &&
                        risk &&
                        experience &&
                        knowledge &&
                        outerAnime && {
                          transform: [
                            { translateX: this.translateX },
                            {
                              rotate: changeRotation
                                ? this.spin
                                : this.rotateBack,
                            },
                          ],
                        },
                    )}
                  >
                    <div
                      id="pie-center"
                      style={{
                        WebkitTransform:
                          "translate3d(0, 0, 0) scale3d(0, 0, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                        MozTransform:
                          "translate3d(0, 0, 0) scale3d(0, 0, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                        msTransform:
                          "translate3d(0, 0, 0) scale3d(0, 0, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                        transform:
                          "translate3d(0, 0, 0) scale3d(0, 0, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                      }}
                      className="af-class-pie-center"
                    />
                    <div className="af-class-pie-menu w-embed">
                      {/*?xml version="1.0" encoding="UTF-8"?*/}
                      <svg
                        width="584px"
                        height="584px"
                        viewBox="0 0 584 584"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        xmlnsXlink="http://www.w3.org/1999/xlink"
                      >
                        <g
                          id="knowledge-segment-container"
                          onClick={() =>
                            knowledge !== true &&
                            this.navigate("OBJ", startAnimation)
                          }
                          className={`af-class-segment-container ${knowledgeClass}`}
                          transform="translate(42.000000, 42.000000)"
                        >
                          <circle
                            id="Oval"
                            cx={250}
                            cy={250}
                            r={250}
                            fillOpacity={0}
                            pointerEvents="none"
                          />
                          <path
                            d="M250.234071,250.032141 L250.179225,250.048511 L250.193847,250.058464 L103.100824,452.19529 C187.503123,513.639527 304.825094,517.502459 394.406406,454.174439 L397.112437,452.234831 L250.234071,250.032141 Z"
                            id="knowledge-segment"
                            fill="var(--module-color-obj)"
                            pointerEvents="visiblePainted"
                          />

                          {firefox ? (
                            <text>
                              <textPath
                                alignmentBaseline="top"
                                xlinkHref="#knowledge-segment"
                                startOffset="50%"
                                textAnchor="middle"
                                fontSize={knowledge ? 32 : 24}
                                fontWeight="var(--font-weight-bold)"
                                line-spacing={32}
                                letterSpacing={knowledge ? 4 : 2}
                                fill="#FFFFFF"
                              >
                                <tspan
                                  x={"0.5em"}
                                  dy={knowledge ? "-2em" : "-1em"}
                                  id="knowledge-label"
                                  className="headFont"
                                >
                                  Knowledge
                                  {knowledge && (
                                    <tspan
                                      x="0em"
                                      dy="1.2em"
                                      letterSpacing={2}
                                      fontSize={24}
                                    >
                                      {knowledgeText}
                                    </tspan>
                                  )}
                                </tspan>
                              </textPath>
                            </text>
                          ) : (
                            <>
                              <text>
                                <textPath
                                  alignmentBaseline="top"
                                  xlinkHref="#knowledge-segment"
                                  startOffset="50%"
                                  textAnchor="middle"
                                  fontSize={knowledge ? 32 : 24}
                                  fontWeight="var(--font-weight-bold)"
                                  line-spacing={32}
                                  letterSpacing={knowledge ? 5 : 2}
                                  fill="#FFFFFF"
                                >
                                  <tspan
                                    x={"0.5em"}
                                    dy={knowledge ? "-2.1em" : "-1.65em"}
                                    id="knowledge-label"
                                    className="headFont"
                                  >
                                    Knowledge
                                  </tspan>
                                </textPath>
                              </text>

                              <text>
                                <textPath
                                  alignmentBaseline="top"
                                  xlinkHref="#knowledge-segment"
                                  startOffset="50%"
                                  textAnchor="middle"
                                  fontWeight="var(--font-weight-bold)"
                                  line-spacing={32}
                                  letterSpacing={2}
                                  fill="#FFFFFF"
                                >
                                  {knowledge && (
                                    <tspan
                                      x="0.5em"
                                      dy="-1.4em"
                                      fontSize={24}
                                      id="knowledge-label"
                                      className="headFont"
                                    >
                                      {knowledgeText}
                                    </tspan>
                                  )}
                                </textPath>
                              </text>
                            </>
                          )}
                        </g>
                        <g
                          id="future-segment-container"
                          onClick={() =>
                            future !== true &&
                            this.navigate("PB", startAnimation)
                          }
                          className={`af-class-segment-container ${futureClass}`}
                          transform="translate(42.000000, 42.000000)"
                        >
                          <circle
                            id="Oval"
                            cx={250}
                            cy={250}
                            r={250}
                            fillOpacity={0}
                            pointerEvents="none"
                          />
                          <path
                            d="M249.932221,250.133081 L249.899707,250.085967 L249.894761,250.102952 L12.2368672,172.643851 C-20.1062022,271.919183 12.4751765,384.71588 100.373351,450.36102 L103.053854,452.335771 L249.932221,250.133081 Z"
                            id="future-segment"
                            fill="var(--module-color-pb)"
                            pointerEvents="visiblePainted"
                          />
                          {firefox ? (
                            <text width={500}>
                              <textPath
                                alignmentBaseline="top"
                                style={{ alignItems: "center" }}
                                xlinkHref="#future-segment"
                                startOffset="50%"
                                textAnchor="middle"
                                fontSize={future ? 32 : 24}
                                fontWeight="var(--font-weight-bold)"
                                line-spacing={32}
                                letterSpacing={future ? 4 : 2}
                                fill="#FFFFFF"
                              >
                                <tspan
                                  x={future && "0em"}
                                  dy={future ? "-2em" : "-1em"}
                                  id="future-label"
                                  className="headFont"
                                >
                                  The Future
                                  {future && (
                                    <tspan
                                      x="0em"
                                      dy="1.2em"
                                      fontSize={future ? 24 : 20}
                                    >
                                      {futureText}
                                    </tspan>
                                  )}
                                </tspan>
                              </textPath>
                            </text>
                          ) : (
                            <>
                              <text width={500}>
                                <textPath
                                  alignmentBaseline="top"
                                  style={{ alignItems: "center" }}
                                  xlinkHref="#future-segment"
                                  startOffset="50%"
                                  textAnchor="middle"
                                  fontSize={future ? 32 : 24}
                                  fontWeight="var(--font-weight-bold)"
                                  line-spacing={32}
                                  letterSpacing={future ? 4 : 2}
                                  fill="#FFFFFF"
                                >
                                  <tspan
                                    x={"0.5em"}
                                    dy={future ? "-2.1em" : "-1.65em"}
                                    id="future-label"
                                    className="headFont"
                                  >
                                    The Future
                                  </tspan>
                                </textPath>
                              </text>
                              <text width={500}>
                                <textPath
                                  alignmentBaseline="top"
                                  style={{ alignItems: "center" }}
                                  xlinkHref="#future-segment"
                                  startOffset="50%"
                                  textAnchor="middle"
                                  fontWeight="var(--font-weight-bold)"
                                  line-spacing={32}
                                  letterSpacing={2}
                                  fill="#FFFFFF"
                                >
                                  {future && (
                                    <tspan
                                      x="0.5em"
                                      dy="-1.4em"
                                      id="future-label"
                                      className="headFont"
                                      fontSize={24}
                                    >
                                      {futureText}
                                    </tspan>
                                  )}
                                </textPath>
                              </text>
                            </>
                          )}
                        </g>
                        <g
                          id="loss-segment-container"
                          onClick={() =>
                            loss !== true && this.navigate("LA", startAnimation)
                          }
                          className={`af-class-segment-container ${lossClass}`}
                          transform="translate(42.000000, 42.000000)"
                        >
                          {/* <title>{lossLabels.loss} &amp; {lossLabels.gain}</title> */}
                          <circle
                            id="Oval"
                            cx={250}
                            cy={250}
                            r={250}
                            fillOpacity={0}
                            pointerEvents="none"
                          />
                          <path
                            d="M249.907775,250.054306 L12.2535857,172.819751 L13.3029752,169.65968 C48.5602276,65.7607325 145.745799,-0.0885282948 250.137215,0 L249.924848,250.009362 L249.942526,250.008819 L249.907775,250.054306 Z"
                            id="loss-segment"
                            fill="var(--module-color-la)"
                            pointerEvents="visiblePainted"
                          />
                          {firefox ? (
                            <text>
                              <textPath
                                alignmentBaseline="top"
                                xlinkHref="#loss-segment"
                                startOffset="50%"
                                textAnchor="middle"
                                fontSize={loss ? 32 : 24}
                                fontWeight="var(--font-weight-bold)"
                                line-spacing={32}
                                letterSpacing={loss ? 4 : 2}
                                fill="#FFFFFF"
                              >
                                <tspan
                                  x={loss && "0em"}
                                  dy={loss ? "2em" : "1.5em"}
                                  id="loss-label"
                                  className="headFont"
                                >
                                  {`${lossLabels.loss} & ${lossLabels.gain}`}{" "}
                                  {loss && (
                                    <tspan x="0em" dy="1.2em" fontSize={24}>
                                      {lossText}
                                    </tspan>
                                  )}
                                </tspan>
                              </textPath>
                            </text>
                          ) : (
                            <>
                              <text>
                                <textPath
                                  alignmentBaseline="top"
                                  xlinkHref="#loss-segment"
                                  startOffset="50%"
                                  textAnchor="middle"
                                  fontSize={loss ? 32 : 24}
                                  fontWeight="var(--font-weight-bold)"
                                  line-spacing={32}
                                  letterSpacing={loss ? 4 : 2}
                                  fill="#FFFFFF"
                                >
                                  <tspan
                                    x={"0.5em"}
                                    dy={"2em"}
                                    id="loss-label"
                                    className="headFont"
                                  >
                                    Loss & Gain
                                  </tspan>
                                </textPath>
                              </text>
                              <text>
                                <textPath
                                  alignmentBaseline="top"
                                  xlinkHref="#loss-segment"
                                  startOffset="50%"
                                  textAnchor="middle"
                                  fontWeight="var(--font-weight-bold)"
                                  line-spacing={32}
                                  letterSpacing={5}
                                  fill="#FFFFFF"
                                >
                                  {loss && (
                                    <tspan
                                      x="0.5em"
                                      dy="3.6em"
                                      fontSize={24}
                                      id="loss-label"
                                      className="headFont"
                                    >
                                      {lossText}
                                    </tspan>
                                  )}
                                </textPath>
                              </text>
                            </>
                          )}
                        </g>
                        <g
                          id="risk-segment-container"
                          onClick={() =>
                            risk !== true &&
                            this.navigate("ATR", startAnimation)
                          }
                          className={`af-class-segment-container ${riskClass}`}
                          transform="translate(42.000000, 42.000000)"
                        >
                          <circle
                            id="Oval"
                            cx={250}
                            cy={250}
                            r={250}
                            fillOpacity={0}
                            pointerEvents="none"
                          />
                          <path
                            style={{
                              justifyContent: "center",
                              alignItems: "center",
                              display: "flex",
                            }}
                            d="M249.975122,250.001018 L249.975122,0.0647467294 L253.304183,0.0864669809 C362.992538,1.51852628 455.637903,73.6181421 487.812277,172.948298 L250.023133,250.00337 L250.029112,250.020018 L249.975122,250.001018 Z"
                            id="risk-segment"
                            fill="var(--module-color-atr)"
                            pointerEvents="visiblePainted"
                          />
                          {firefox ? (
                            <text>
                              <textPath
                                alignmentBaseline="top"
                                xlinkHref="#risk-segment"
                                startOffset="50%"
                                textAnchor="middle"
                                fontSize={risk ? 32 : 24}
                                fontWeight="var(--font-weight-bold)"
                                line-spacing={32}
                                letterSpacing={risk ? 4 : 2}
                                fill="#FFFFFF"
                              >
                                <tspan
                                  x={
                                    risk
                                      ? !!riskText && riskText.length > 6
                                        ? "0em"
                                        : "0em"
                                      : null
                                  }
                                  dy={risk ? "2em" : "1.5em"}
                                  id="risk-label"
                                  className="headFont"
                                >
                                  Risk
                                  {risk && (
                                    <tspan x="0em" dy="1.2em" fontSize={24}>
                                      {riskText}
                                    </tspan>
                                  )}
                                </tspan>
                              </textPath>
                            </text>
                          ) : (
                            <>
                              <text>
                                <textPath
                                  alignmentBaseline="top"
                                  xlinkHref="#risk-segment"
                                  startOffset="50%"
                                  textAnchor="middle"
                                  fontSize={risk ? 32 : 24}
                                  fontWeight="var(--font-weight-bold)"
                                  line-spacing={32}
                                  letterSpacing={risk ? 4 : 2}
                                  fill="#FFFFFF"
                                >
                                  <tspan
                                    x={"0.4em"}
                                    dy={"2em"}
                                    id="risk-label"
                                    className="headFont"
                                  >
                                    {RISK}
                                  </tspan>
                                </textPath>
                              </text>
                              <text>
                                <textPath
                                  alignmentBaseline="top"
                                  xlinkHref="#risk-segment"
                                  startOffset="50%"
                                  textAnchor="middle"
                                  fontWeight="var(--font-weight-bold)"
                                  line-spacing={32}
                                  letterSpacing={4}
                                  fill="#FFFFFF"
                                >
                                  {risk && (
                                    <tspan
                                      x="0.45em"
                                      dy="3.6em"
                                      fontSize={24}
                                      id="risk-label"
                                      className="headFont"
                                    >
                                      {riskText}
                                    </tspan>
                                  )}
                                </textPath>
                              </text>
                            </>
                          )}
                        </g>
                        <g
                          id="experience-segment-container"
                          onClick={() =>
                            experience !== true &&
                            this.navigate("EXP", startAnimation)
                          }
                          className={`af-class-segment-container ${experienceClass}`}
                          transform="translate(42.000000, 42.000000)"
                        >
                          {/* <title>{EXPERIENCE}</title> */}
                          <circle
                            id="Oval"
                            cx={250}
                            cy={250}
                            r={250}
                            fillOpacity={0}
                            pointerEvents="none"
                          />
                          <path
                            d="M250.043154,250.051461 L250.043154,250.108692 L250.057137,250.097859 L396.806543,452.484389 C481.313102,391.183684 521.240689,280.77441 488.70681,175.990401 L487.698726,172.816906 L250.043154,250.051461 Z"
                            id="experience-segment"
                            fill="var(--module-color-exp)"
                            pointerEvents="visiblePainted"
                          />
                          {firefox ? (
                            <text>
                              <textPath
                                alignmentBaseline="top"
                                xlinkHref="#experience-segment"
                                startOffset="50%"
                                textAnchor="middle"
                                fontSize={experience ? 32 : 24}
                                fontWeight="var(--font-weight-bold)"
                                line-spacing={32}
                                letterSpacing={experience ? 5 : 2}
                                fill="var(--text-color-default)"
                              >
                                <tspan
                                  x={
                                    experience
                                      ? !!experienceText &&
                                        experienceText.length > 8
                                        ? "0em"
                                        : "0em"
                                      : null
                                  }
                                  dy={experience ? "-2em" : "-1em"}
                                  id="experience-label"
                                  className="headFont"
                                >
                                  {EXPERIENCE}{" "}
                                  {experience && (
                                    <tspan
                                      x={
                                        experienceText &&
                                        experienceText.length < 7
                                          ? "0em"
                                          : "0em"
                                      }
                                      dy="1.2em"
                                      fontSize={24}
                                      letterSpacing={2}
                                    >
                                      {experienceText}
                                    </tspan>
                                  )}
                                </tspan>
                              </textPath>
                            </text>
                          ) : (
                            <>
                              <text>
                                <textPath
                                  alignmentBaseline="top"
                                  xlinkHref="#experience-segment"
                                  startOffset="50%"
                                  textAnchor="middle"
                                  fontSize={experience ? 32 : 24}
                                  fontWeight="var(--font-weight-bold)"
                                  line-spacing={32}
                                  letterSpacing={experience ? 5 : 2}
                                  fill="var(--text-color-default)"
                                >
                                  <tspan
                                    x={"0.5em"}
                                    dy={experience ? "-2.2em" : "-1.65em"}
                                    id="experience-label"
                                    className="headFont"
                                  >
                                    {EXPERIENCE}
                                  </tspan>
                                </textPath>
                              </text>
                              <text>
                                <textPath
                                  alignmentBaseline="top"
                                  xlinkHref="#experience-segment"
                                  startOffset="50%"
                                  textAnchor="middle"
                                  fontWeight="var(--font-weight-bold)"
                                  line-spacing={32}
                                  letterSpacing={2}
                                  fill="var(--text-color-default)"
                                >
                                  {experience && (
                                    <tspan
                                      x={"0.5em"}
                                      dy="-1.5em"
                                      id="experience-label"
                                      className="headFont"
                                      fontSize={24}
                                    >
                                      {experienceText}
                                    </tspan>
                                  )}
                                </textPath>
                              </text>
                            </>
                          )}
                        </g>
                      </svg>
                    </div>
                  </Animated.View>
                )}

                {future &&
                  loss &&
                  risk &&
                  experience &&
                  knowledge &&
                  !outerAnime && (
                    <a
                      data-w-id="21d44e33-f1b1-0eb8-9bf2-929abc310957"
                      onClick={(e) => {
                        e.preventDefault();
                        this.continueHandle();
                      }}
                      href="#"
                      className="af-class-button w-inline-block af-class-custom"
                      style={{
                        position: "absolute",
                        bottom: -50,

                        backgroundColor: "#2F2F2F",
                      }}
                    >
                      <div
                        style={{ fontWeight: "var(--font-weight-semi-bold)" }}
                      >
                        {buttonText}
                      </div>
                    </a>
                  )}
                <a
                  id="continue-button"
                  data-w-id="d41feff6-a8d5-9686-0548-144de3d37523"
                  href="#"
                  className="af-class-button af-class-continue-button w-inline-block"
                >
                  <div>{buttonText}</div>
                </a>
              </div>
              <div
                style={Object.assign(
                  {
                    WebkitTransform:
                      "translate3d(0, 50vh, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    MozTransform:
                      "translate3d(0, 50vh, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    msTransform:
                      "translate3d(0, 50vh, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    transform:
                      "translate3d(0, 50vh, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                  },
                  isCompleted && { opacity: 0, display: "none" },
                )}
                className={`af-class-deconstructed-menu ${
                  !this.state.continuePressed && "test-demo"
                }`}
              >
                <img
                  src={
                    require("../assets/images/mandg/segments/Knowledge-Segment.svg")
                      .default
                  }
                  loading="lazy"
                  style={{
                    WebkitTransform:
                      "translate3d(0, 0, 0) scale3d(1.1, 1.1, 1) rotateX(0) rotateY(0) rotateZ(180deg) skew(0, 0)",
                    MozTransform:
                      "translate3d(0, 0, 0) scale3d(1.1, 1.1, 1) rotateX(0) rotateY(0) rotateZ(180deg) skew(0, 0)",
                    msTransform:
                      "translate3d(0, 0, 0) scale3d(1.1, 1.1, 1) rotateX(0) rotateY(0) rotateZ(180deg) skew(0, 0)",
                    transform:
                      "translate3d(0, 0, 0) scale3d(1.1, 1.1, 1) rotateX(0) rotateY(0) rotateZ(180deg) skew(0, 0)",
                  }}
                  alt
                  className="af-class-menu-segment af-class-knowledge"
                />
                <img
                  src={
                    require("../assets/images/mandg/segments/Risk-Segment.svg")
                      .default
                  }
                  loading="lazy"
                  style={{
                    WebkitTransform:
                      "translate3d(0, 0, 0) scale3d(1.2, 1.2, 1) rotateX(0) rotateY(0) rotateZ(260deg) skew(0, 0)",
                    MozTransform:
                      "translate3d(0, 0, 0) scale3d(1.2, 1.2, 1) rotateX(0) rotateY(0) rotateZ(260deg) skew(0, 0)",
                    msTransform:
                      "translate3d(0, 0, 0) scale3d(1.2, 1.2, 1) rotateX(0) rotateY(0) rotateZ(260deg) skew(0, 0)",
                    transform:
                      "translate3d(0, 0, 0) scale3d(1.2, 1.2, 1) rotateX(0) rotateY(0) rotateZ(260deg) skew(0, 0)",
                  }}
                  alt
                  className="af-class-menu-segment af-class-risk"
                />
                <img
                  src={
                    require("../assets/images/mandg/segments/Future-Segment.svg")
                      .default
                  }
                  loading="lazy"
                  style={{
                    WebkitTransform:
                      "translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(-190deg) skew(0, 0)",
                    MozTransform:
                      "translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(-190deg) skew(0, 0)",
                    msTransform:
                      "translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(-190deg) skew(0, 0)",
                    transform:
                      "translate3d(0, 0, 0) scale3d(1, 1, 1) rotateX(0) rotateY(0) rotateZ(-190deg) skew(0, 0)",
                  }}
                  alt
                  className="af-class-menu-segment af-class-future"
                />
                <img
                  src={
                    require("../assets/images/mandg/segments/Experience-Segment.svg")
                      .default
                  }
                  loading="lazy"
                  style={{
                    WebkitTransform:
                      "translate3d(0, 0, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(-154deg) skew(0, 0)",
                    MozTransform:
                      "translate3d(0, 0, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(-154deg) skew(0, 0)",
                    msTransform:
                      "translate3d(0, 0, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(-154deg) skew(0, 0)",
                    transform:
                      "translate3d(0, 0, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(-154deg) skew(0, 0)",
                  }}
                  alt
                  className="af-class-menu-segment af-class-experience"
                />
                <img
                  src={
                    require("../assets/images/mandg/segments/Loss-Segment.svg")
                      .default
                  }
                  loading="lazy"
                  style={{
                    WebkitTransform:
                      "translate3d(0, 0, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(116deg) skew(0, 0)",
                    MozTransform:
                      "translate3d(0, 0, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(116deg) skew(0, 0)",
                    msTransform:
                      "translate3d(0, 0, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(116deg) skew(0, 0)",
                    transform:
                      "translate3d(0, 0, 0) scale3d(0.8, 0.8, 1) rotateX(0) rotateY(0) rotateZ(116deg) skew(0, 0)",
                  }}
                  alt
                  className="af-class-menu-segment af-class-loss"
                />

                <div
                  id="pie-center"
                  data-w-id="cc122b65-d439-587c-1ce5-495a0e65dff1"
                  style={{
                    WebkitTransform:
                      "translate3d(0, 0, 0) scale3d(0, 0, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    MozTransform:
                      "translate3d(0, 0, 0) scale3d(0, 0, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    msTransform:
                      "translate3d(0, 0, 0) scale3d(0, 0, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                    transform:
                      "translate3d(0, 0, 0) scale3d(0, 0, 1) rotateX(0) rotateY(0) rotateZ(0) skew(0, 0)",
                  }}
                  className="af-class-pie-center"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(IndexView);

/* eslint-enable */
